export const REFERENCE_CONTACTS = Object.freeze([
  {
    id: "andre.oleary@rosemountfs.co.uk",
    name: "Andre O'Leary",
    email: "andre.oleary@rosemountfs.co.uk",
  },
  {
    id: "callum.wilkinson@rosemountfs.co.uk",
    email: "callum.wilkinson@rosemountfs.co.uk",
    name: "Callum Wilkinson",
  },
  {
    id: "angel.strongitharm@rosemountfs.co.uk",
    email: "angel.strongitharm@rosemountfs.co.uk",
    name: "Angel Strongitharm",
  },
  {
    id: "grace.furner@rosemountfs.co.uk",
    email: "grace.furner@rosemountfs.co.uk",
    name: "Grace Furner",
  },
]);

export const DEFAULT_REFERENCE_CONTACT = REFERENCE_CONTACTS[0];
